import type { Deck } from '../types';

type Props = {
  deck: Deck | undefined;
  myVote: string | null;
  disabled: boolean;
  onPick: (cardId: string | null) => void;
};

export const Hand = ({ deck, myVote, disabled, onPick }: Props) => {
  if (!deck) return null;

  return (
    <div className="hand" role="group" aria-label="Your cards">
      {deck.cards.map((card) => {
        const selected = card.id === myVote;
        return (
          <button
            key={card.id}
            type="button"
            className={`card${selected ? ' card-selected' : ''}`}
            disabled={disabled}
            aria-pressed={selected}
            // Clicking the played card takes it back, which is friendlier than
            // hunting for a separate "clear" control.
            onClick={() => onPick(selected ? null : card.id)}
          >
            {card.label}
          </button>
        );
      })}
    </div>
  );
};
